import type { Address } from '@strata-monorepo/shared-ui/types/Address'

/**
 * Service functions for interacting with SmartyStreets Autocomplete API
 */

interface SmartyStreetsResponse {
  suggestions: Address[]
}

/**
 * Fetch address suggestions from SmartyStreets Autocomplete API
 *
 * Note: Do not place secrets in front-end code. If this key must remain client-side,
 * ensure it is a public/browser key with limited scope and quotas. Prefer environment
 * variables and proxying through a backend when possible.
 */
export async function getSmartyAutoComplete(query: string): Promise<Address[]> {
  if (query.length < 3) return []

  try {
    const key = '151931295502736746' // TODO: move to env or proxy through backend
    const maxResults = 6
    const url = `https://us-autocomplete-pro.api.smartystreets.com/lookup?key=${key}&search=${encodeURIComponent(
      query,
    )}&max_results=${maxResults}`

    const result = await fetch(url)
    const data = (await result.json()) as SmartyStreetsResponse
    return data.suggestions
  } catch (error) {
    // In a service layer, we just log and return empty; UI can decide how to handle
    // TODO: Integrate with Incense/New Relic as appropriate
    console.error('Error fetching address suggestions:', error)
    return []
  }
}
